// CM ↔ Feet/Inches conversions. 1 inch = 2.54 cm exactly; 1 ft = 30.48 cm.

export const CM_PER_INCH = 2.54;
export const CM_PER_FOOT = 30.48;

export interface FeetInches {
  feet: number;
  inches: number;          // remainder, may be fractional
  totalInches: number;
  decimalFeet: number;
  meters: number;
  cm: number;
}

export function cmToFeetInches(cm: number): FeetInches {
  const totalInches = cm / CM_PER_INCH;
  const feet = Math.floor(totalInches / 12);
  const inches = totalInches - feet * 12;
  return {
    feet,
    inches,
    totalInches,
    decimalFeet: cm / CM_PER_FOOT,
    meters: cm / 100,
    cm,
  };
}

export function feetInchesToCm(feet: number, inches: number): FeetInches {
  const totalInches = feet * 12 + inches;
  const cm = totalInches * CM_PER_INCH;
  return {
    feet,
    inches,
    totalInches,
    decimalFeet: cm / CM_PER_FOOT,
    meters: cm / 100,
    cm,
  };
}

/** Round inches to a sensible display (e.g., 5'4.96" or 5'5"). */
export function formatFtIn(f: FeetInches, precise = false): string {
  if (precise) {
    return `${f.feet}'${f.inches.toFixed(2)}"`;
  }
  // Round inches to nearest whole inch, but cascade to feet on overflow
  let inches = Math.round(f.inches);
  let feet = f.feet;
  if (inches === 12) { feet += 1; inches = 0; }
  return `${feet}'${inches}"`;
}

// === Reference data ===

export const BD_AVG = {
  male:   { cm: 163.8, label: "Bangladesh average male" },
  female: { cm: 151.8, label: "Bangladesh average female" },
};
export const GLOBAL_AVG = {
  male:   { cm: 171, label: "Global average male" },
  female: { cm: 159, label: "Global average female" },
};

/** Very rough percentile estimator vs BD population (mixed M/F mean ≈ 157.8 cm, sd ≈ 8). */
export function bdHeightPercentile(cm: number): number {
  const mean = 157.8;
  const sd = 8;
  const z = (cm - mean) / sd;
  // Cumulative normal approximation (Abramowitz & Stegun 26.2.17)
  const t = 1 / (1 + 0.2316419 * Math.abs(z));
  const d = 0.3989423 * Math.exp(-z * z / 2);
  let p = d * t * (0.3193815 + t * (-0.3565638 + t * (1.781478 + t * (-1.821256 + t * 1.330274))));
  if (z > 0) p = 1 - p;
  return Math.round(p * 100);
}

export const HEIGHT_TABLE_CM: number[] = [
  140, 145, 150, 152, 155, 157, 160, 162, 165, 167, 170, 172, 175, 178, 180, 183, 185, 188, 190, 193, 195, 200,
];
